import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import { ChevronsUpDown, X } from "lucide-react";

/** Pick any number of values from a list — used by the page filters. */
export function MultiSelect({ label, options, value = [], onChange, width = "w-44", testId, emptyLabel = "All" }) {
  const opts = (options || []).filter(Boolean);
  const selected = value || [];
  const toggle = (v) => onChange(selected.includes(v) ? selected.filter((x) => x !== v) : [...selected, v]);
  const summary = selected.length === 0 ? emptyLabel
    : selected.length === 1 ? String(selected[0])
      : `${selected.length} selected`;

  return (
    <div>
      {label && <div className="text-xs text-zinc-400 mb-1">{label}</div>}
      <Popover>
        <PopoverTrigger asChild>
          <button type="button" data-testid={testId}
            className={`${width} h-9 px-3 border rounded-md bg-white text-sm text-left flex items-center justify-between gap-2 hover:border-cc-blue ${selected.length ? "border-cc-blue text-cc-blue" : "text-zinc-600"}`}>
            <span className="truncate">{summary}</span>
            {selected.length > 0
              ? <X className="w-3.5 h-3.5 shrink-0" onClick={(e) => { e.stopPropagation(); onChange([]); }} data-testid={`${testId}-clear`} />
              : <ChevronsUpDown className="w-3.5 h-3.5 shrink-0 text-zinc-400" />}
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-56 p-2 max-h-72 overflow-y-auto cc-scroll">
          {opts.length === 0 ? <p className="text-xs text-zinc-400 px-2 py-1.5">Nothing to filter on yet.</p> : opts.map((o) => {
            const val = typeof o === "string" ? o : o.value;
            const text = typeof o === "string" ? o : o.label;
            return (
              <label key={val} className="flex items-center gap-2 text-sm px-2 py-1.5 rounded hover:bg-zinc-50 cursor-pointer">
                <Checkbox checked={selected.includes(val)} onCheckedChange={() => toggle(val)} data-testid={`${testId}-${val}`} />
                <span className="truncate text-zinc-700">{text}</span>
              </label>
            );
          })}
        </PopoverContent>
      </Popover>
    </div>
  );
}
